import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import DeterminantesTable from './_DeterminantesTable';
import EditDeterminante from './_EditDeterminante';
const URI = ApiEndpoint + 'administration/';

const Determinantes = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [determinantes, setDeterminantes] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [idDeterminanteEdit, setIdDetermnanteEdit] = useState(null);

  const handleClose = () => {
    setOpenModal(false);
    getDeterminantes();
  };

  const getDeterminantes = async () => {
    setDeterminantes(null);

    httpClient('GET', URI + 'alldeterminantes', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setDeterminantes(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getDeterminantes();
  }, []);
  return (
    <>
      {determinantes && (
        <DeterminantesTable
          determinantes={determinantes}
          setIdDeterminanteEdit={setIdDetermnanteEdit}
          setOpenModal={setOpenModal}
        />
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idDeterminanteEdit > 0 ? 'Editar' : 'Agregar') + ' Determinante'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditDeterminante
            idDeterminante={idDeterminanteEdit}
            closeModal={handleClose}
          ></EditDeterminante>
        </MyModal>
      )}
    </>
  );
};

export default Determinantes;
